var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88889 11.8V7C5.88889 5.4087 6.53274 3.88258 7.67879 2.75736C8.82485 1.63214 10.3792 1 12 1C13.6208 1 15.1752 1.63214 16.3212 2.75736C17.4673 3.88258 18.1111 5.4087 18.1111 7V11.8M3.44444 11.8H20.5556C21.9056 11.8 23 12.8745 23 14.2V22.6C23 23.9255 21.9056 25 20.5556 25H3.44444C2.09441 25 1 23.9255 1 22.6V14.2C1 12.8745 2.09441 11.8 3.44444 11.8Z",
    stroke: "currentColor",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.194ee8a62327aa29d01372d8b68c49e8.svg";
export { ForwardRef as ReactComponent };